"use client";

import { c as _c } from "react/compiler-runtime";
import { track } from "@opensea/analytics";
import { useConnectFlow as useWalletConnectFlow } from "@opensea/wallet";
import { useConnectedAccountServerHint } from "./use-connected-account-server-hint";
export function useConnectFlow(t0) {
  const $ = _c(4);
  const {
    source
  } = t0;
  const connectFlow = useWalletConnectFlow();
  const [, setServerHint] = useConnectedAccountServerHint();
  let t1;
  if ($[0] !== connectFlow || $[1] !== setServerHint || $[2] !== source) {
    t1 = t2 => {
      const {
        onConnected,
        onAuthenticated,
        event,
        switchOnConnect: t3,
        chainArch: t4
      } = t2 === undefined ? {} : t2;
      const switchOnConnect = t3 === undefined ? true : t3;
      const chainArch = t4 === undefined ? undefined : t4;
      track("Wallet Begin", {
        source
      }, event);
      connectFlow({
        switchOnConnect,
        chainArch,
        onAuthenticated,
        onConnected: (connectedAddress, chain, connector) => {
          onConnected?.(connectedAddress, chain, connector);
          track("Wallet Connected", {
            source
          }, event);
          setServerHint(connectedAddress);
        }
      });
    };
    $[0] = connectFlow;
    $[1] = setServerHint;
    $[2] = source;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}